import { trackGtagEvent } from '@/lib/gtag'
import { trackPlausibleEvent } from '@/lib/plausible'

const DEFAULT_TURNSTILE_EVENT_PROPS = {
  event_category: 'verification',
  event_label: 'markdown_to_pdf_turnstile',
}

export const trackTurnstileEvent = (
  action: string,
  props?: Record<string, unknown>,
) => {
  const eventProps = {
    ...DEFAULT_TURNSTILE_EVENT_PROPS,
    ...props,
  }

  trackGtagEvent(action, eventProps)
  trackPlausibleEvent(action, eventProps)
}
